// extracted by mini-css-extract-plugin
export default {"root":"NumberPad_root__p+rbA","button":"NumberPad_button__nJNKX","num":"NumberPad_num__RVNJU"};